// Every incoming request endpoint is typed by the service it belongs to; this is the
// winter service's own segment.
export const REQUESTS_TYPE = 'winter-service'

export const REQUESTS_ENDPOINT = `incoming-requests/${REQUESTS_TYPE}`

export const buildRequestEndpoint = (requestId) => `${REQUESTS_ENDPOINT}/${requestId}`
export const buildRequestStreetsEndpoint = (requestId) => `${buildRequestEndpoint(requestId)}/streets`
export const buildRequestLogsEndpoint = (requestId) => `${buildRequestEndpoint(requestId)}/logs`

// Turning requests into work orders. One call takes every picked request at once and
// writes the same start time on each - which is why the confirmation asks for it.
export const REQUESTS_TO_WORK_ORDERS_ENDPOINT = 'winter-service-tasks/incoming-requests/process'

// The request's source is the department it comes from, the same as for every other
// request type.
export const DEPARTMENTS_AUTOCOMPLETE_ENDPOINT = 'departments/autocomplete'

export const REQUESTS_TABLE_KEY = 'winter-service-v2-requests'
export const REQUESTS_UI_VIEW = 'winter_service2_requests'

export const REQUESTS_INDEX_ROUTE = 'WinterService2Requests'
export const REQUEST_DETAILS_ROUTE = 'WinterService2RequestDetails'
export const REQUEST_CREATE_ROUTE = 'WinterService2RequestCreate'

export const REQUESTS_TRANSLATION_NAMESPACE = 'road-maintenance/winter_service2/requests'

// The tab keys are what TabsLayout locks tabs by, so they have to be stable and
// distinct - see useRequestBasicInfo for the warning that lock drives.
export const REQUEST_BASIC_INFO_TAB_KEY = 'request_basic_information'
export const REQUEST_STREETS_TAB_KEY = 'request_streets'

export const REQUEST_STREETS_TABLE_KEY = 'winter-service-v2-request-streets'

// A request whose vehicle or driver can no longer take it is marked so the user sees it
// before trying to make a work order out of it: the row is tinted, and the offending
// value itself is painted red.
export const ABNORMAL_ROW_COLOR = '#FEF3C7'
export const ABNORMAL_VALUE_COLOR = '#EF4444'

// Put on the details screen's vehicle/driver field when the picked one can no longer
// take the request - RequestDetailsInfo paints the field's own outline from it.
export const ABNORMAL_FIELD_CLASS = 'request-field--abnormal'
